import concat from 'lodash/concat';
import reduce from 'lodash/reduce';
import startCase from 'lodash/startCase';

import bioRoundedContent from './bio_rounded.js';
import bioStandardContent from './bio_standard.js';
import bioStandardSingle from './bio_standard_single.js';
import bioRoundedSingle from './bio_rounded_single.js';
import imageAndTextBordered from './image_and_text_bordered.js';
import imageAndTextFullBleed from './image_and_text_full_bleed.js';
import videoAndTextBordered from './video_and_text_bordered.js';
import videoAndTextFullBleed from './video_and_text_full_bleed.js';

import {
  BLOCK_TYPE_CONTENT,

  CATEGORY_TAG_TILES,
  CATEGORY_TAG_CREATORS
} from 'const_shared/blocks/block_definitions.js';

import {
  CONTENT_TYPE_TEXT,
  CONTENT_TYPE_PHOTO,
  CONTENT_TYPE_IFRAME_EMBED,
  CONTENT_TYPE_PRESENTATION,
  CONTENT_TYPE_OTHER,
  CONTENT_TYPE_WEB_PREVIEW,
  CONTENT_TYPE_VIDEO,
  CONTENT_TYPE_YOUTUBE,
  CONTENT_TYPE_FORM,
  CONTENT_TYPE_FILE,
  CONTENT_TYPE_HTML_PACKAGE
} from 'zoomforth_codesbane_viewer/const/sections.js';

export const TILE_CREATOR_TYPE_MEDIA = 'media';
export const TILE_CREATOR_TYPE_UPLOAD = 'upload';
export const TILE_CREATOR_TYPE_RECORD_VIDEO = 'record_video';
export const TILE_CREATOR_TYPE_CLIPBOARD = 'clipboard';
export const TILE_CREATOR_TYPE_PASTE = 'paste';

const CONTENT_TILE_TYPE_NAMES = Object.freeze([
  CONTENT_TYPE_PHOTO,
  CONTENT_TYPE_IFRAME_EMBED,
  CONTENT_TYPE_HTML_PACKAGE,
  CONTENT_TYPE_PRESENTATION,
  CONTENT_TYPE_OTHER,
  CONTENT_TYPE_WEB_PREVIEW,
  CONTENT_TYPE_VIDEO,
  CONTENT_TYPE_YOUTUBE,
  CONTENT_TYPE_FORM,
  CONTENT_TYPE_FILE
]);

const CONTENT_TILE_CREATOR_TILE_TYPE_NAMES = Object.freeze([
  TILE_CREATOR_TYPE_MEDIA,
  TILE_CREATOR_TYPE_UPLOAD,
  CONTENT_TYPE_TEXT,
  TILE_CREATOR_TYPE_RECORD_VIDEO,
  CONTENT_TYPE_YOUTUBE,
  CONTENT_TYPE_FORM,
  CONTENT_TYPE_WEB_PREVIEW,
  CONTENT_TYPE_PRESENTATION,
  CONTENT_TYPE_IFRAME_EMBED,
  CONTENT_TYPE_HTML_PACKAGE,
  TILE_CREATOR_TYPE_CLIPBOARD,
  TILE_CREATOR_TYPE_PASTE
]);

const CONTENT_TILE_TYPE_NAMES_TO_CONTENT_TILE_DESCRIPTION_MAP = Object.freeze({
  [TILE_CREATOR_TYPE_MEDIA]: 'Media from library',
  [TILE_CREATOR_TYPE_UPLOAD]: 'Upload media',
  [CONTENT_TYPE_TEXT]: 'Text',
  [TILE_CREATOR_TYPE_RECORD_VIDEO]: 'Record video',
  [CONTENT_TYPE_YOUTUBE]: 'YouTube video',
  [CONTENT_TYPE_FORM]: 'Form',
  [CONTENT_TYPE_WEB_PREVIEW]: 'Web preview',
  [CONTENT_TYPE_PRESENTATION]: 'Presentation',
  [CONTENT_TYPE_IFRAME_EMBED]: 'Embed',
  [CONTENT_TYPE_HTML_PACKAGE]: 'HTML package',
  [TILE_CREATOR_TYPE_CLIPBOARD]: 'Clipboard',
  [TILE_CREATOR_TYPE_PASTE]: 'Paste'
});

function generateExistingContentTileCreatorTiles() {
  const existingContentTileCreators = reduce(CONTENT_TILE_CREATOR_TILE_TYPE_NAMES,
    (contentTileCreators, contentTileCreatorName) => {
      const contentTileCreator = {
        blockType: BLOCK_TYPE_CONTENT,
        blockSubtype: contentTileCreatorName,
        itemType: contentTileCreatorName,
        tags: [contentTileCreatorName, CATEGORY_TAG_TILES, CATEGORY_TAG_CREATORS],
        description: (
          CONTENT_TILE_TYPE_NAMES_TO_CONTENT_TILE_DESCRIPTION_MAP[
            `${contentTileCreatorName}`
          ]
        )
      };

      contentTileCreators.push(contentTileCreator);

      return contentTileCreators;
    }, []
  );

  return existingContentTileCreators;
};

function generateExistingBlocksContent() {
  const existingBlocksObjects = reduce(CONTENT_TILE_TYPE_NAMES,
    (blocksObjects, contentTypeName) => {
      const blockObject = {
        blockType: BLOCK_TYPE_CONTENT,
        blockSubtype: contentTypeName,
        itemType: contentTypeName,
        tags: [contentTypeName],
        description: startCase(contentTypeName)
      };

      blocksObjects.push(blockObject);

      return blocksObjects;
    }, []
  );

  return existingBlocksObjects;
};

export const existingContentTileCreators = Object.freeze(
  generateExistingContentTileCreatorTiles()
);

export const existingBlocksContent = Object.freeze(
  generateExistingBlocksContent()
);


// Really there should be a better way to add these.
const predefinedBlocksContent = Object.freeze(concat([],
  existingBlocksContent,
  bioRoundedContent,
  bioStandardContent,
  bioStandardSingle,
  bioRoundedSingle,
  imageAndTextBordered,
  imageAndTextFullBleed,
  videoAndTextBordered,
  videoAndTextFullBleed
));


export default predefinedBlocksContent;